{
  "enum": {
    "IxcFeesV1FeeRateStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcFeesV1FeeType": {
      "CAT": "CAT",
      "SEC": "SEC",
      "TAF": "TAF",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcFeesV1FeeRateQueryServiceFeeRateListFilterableFields": {
      "effectiveDate": "Effective Date",
      "feeType": "Fee Type",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcFeesV1FeeRateEventType": {
      "created": "Created",
      "updated": "Updated"
    }
  },
  "sortEnum": {
    "IxcFeesV1FeeRateQueryServiceFeeRateListSortableFields": {
      "effectiveDate": "Effective Date",
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}